export default {
    init() {
        const $committee = $('.block-committee');

        if ($committee && $committee.length) {
            $('.member-container', $committee).on('click', function() {
                $('.member-thumb-img', $committee).removeClass('active');

                const fullImg = $('.member-thumb-img', this).data('src');
                const detail = $('.member-hidden-detail', this).html();
                $('.member-detail', $committee).html(detail);
                $('.member-thumb-img', this).addClass('active');

                $('.member-img', $committee).fadeOut(100, 'linear', function() {
                    $('.member-img', $committee).attr('src', fullImg);
                    $('.member-img', $committee).fadeIn(100);
                });
            });
        }
    },

    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
}



// WEBPACK FOOTER //
// ./scripts/routes/blocks/committee.js